<template lang="pug">
v-card
    v-toolbar(flat dense)
        v-tabs(v-model="tab")
            v-tab Survey Group Manager
            v-tab(v-if="$accessable(['bhSurveyOptionsCreate'])") Survey User Manager
            v-tab Campaign Survey Manager
    
    v-tabs-items(v-model="tab")
        survey-group-manager
        survey-user-manager(v-if="$accessable(['bhSurveyOptionsCreate'])")
        campaign-survey-manager
        
</template>

<script>
import SurveyGroupManager from './components/SurveyGroupManager.vue';
import SurveyOptionsManager from './components/SurveyOptionsManager.vue';
import SurveyUserManager from './components/SurveyUserManager.vue';
import CampaignSurveyManager from './components/CampaignSurveyManager.vue';

export default {
    data() { 
        return {
            tab: null
        };
    },
    components: {
        SurveyGroupManager,
        SurveyOptionsManager,
        SurveyUserManager,
        CampaignSurveyManager
    }
}
</script>